import { useStyleProvider } from '@soteria/design-system-ve';

/**
 * Debug component to display the current theme
 */
export function ThemeDebug() {
  const { theme } = useStyleProvider();

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '10px',
        right: '10px',
        padding: '5px 10px',
        backgroundColor: 'rgba(0,0,0,0.7)',
        color: 'white',
        borderRadius: '4px',
        zIndex: 9999,
      }}
    >
      Current Theme: {theme}
    </div>
  );
}
